import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const testimonials = [
  {
    title: "Quick Start with them !",
    text: "“I wasn’t sure if my book would get noticed, but these guys really know what they’re doing. Thanks to their strategy, my book hit #1 on Amazon. Definitely worth it”",
    name: "Arvind Rao",
    role: "Developer",
    img: "/male1.jpeg",
  },
  {
    title: "Content is the king",
    text: "“I had the content, but they gave it the visibility it deserved. Their support was honest, professional, and result oriented. My book became a bestseller within 14 days”",
    name: "Neelima Verma",
    role: "Designer",
    img: "/girl1.jpeg",
  },
  {
    title: "Quick Start with them !",
    text: "“What impressed me the most was how hands-on and transparent the team was. They didn’t just promise results, they delivered. My book went #1, and it felt completely organic”",
    name: "⁠Kartik Sen",
    role: "Developer",
    img: "/male2.jpeg",
  },
  {
    title: "Quick Start with them !",
    text: "“I’ve worked with a few marketing services before, but this was different. No fluff, just clear action, genuine advice, and real results. Couldn’t believe when I saw the #1 badge”",
    name: "Meera Iyer",
    role: "Developer",
    img:"/hero1.jpeg"
  },
  {
    title: "Content is the king",
    text: "“I was skeptical at first, but their process is solid. They understood my book, my audience, and pushed it the right way. Bestseller status wasn’t a fluke, it was strategy”",
    name: "Raghav Malhotra",
    role: "Designer",
    img: "/male3.jpeg",

  },
];

const TestimonialCarousel = () => {
  return (
    <section
      id="testimonials"
      className="bg-white py-16 px-6 md:px-20 text-center"
    >
      <h5 className="text-pink-600 uppercase text-sm tracking-wide mb-2">
        Love from clients
      </h5>
      <h2 className="text-3xl md:text-4xl font-bold text-[#322a52] mb-6">
        See what readers across the world have to say about our work.
      </h2>
      <div className="mb-4">
        <div className="w-20 h-1 border-b-2 border-dotted border-[#322a52] mx-auto"></div>
      </div>

      {/* Description */}
      <p className="text-gray-600 text-xs max-w-xl mx-auto mb-6 mb-12">
          Our team invests time and resources into every project, for this
          reason, all payments are non-refundable.
        </p>

      <Swiper
        spaceBetween={30}
        slidesPerView={1}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        modules={[Navigation, Autoplay]}
        breakpoints={{
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
        className="w-full"
      >
        {testimonials.map((item, idx) => (
          <SwiperSlide key={idx}>
            <div className="bg-[#f9f9f9] rounded-lg p-6 text-left shadow-md hover:shadow-lg transition duration-300 h-full flex flex-col justify-between">
              <div className="mb-4">
                <div className="bg-pink-600 inline-block p-2 rounded-sm mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="#fff"
                    viewBox="0 0 24 24"
                  >
                    <path d="M7.17 6.17A4 4 0 0 1 11 10v4a4 4 0 0 1-4 4H5v-4h2v-2H5V6h2a4 4 0 0 1 .17.17ZM17.17 6.17A4 4 0 0 1 21 10v4a4 4 0 0 1-4 4h-2v-4h2v-2h-2V6h2a4 4 0 0 1 .17.17Z" />
                  </svg>
                </div>
                <p className="text-gray-600 text-sm">{item.text}</p>
              </div>
              <div className="flex items-center gap-3 mt-4">
                <img
                  src={item.img}
                  alt={item.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="font-semibold text-[#322a52]">{item.name}</p>
                  {/* <p className="text-gray-500 text-sm">{item.role}</p> */}
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default TestimonialCarousel;
